import { ConversationInterface } from "../interfaces/conversationInterface";

export const isGroupConversation = (conversation: ConversationInterface) => {
  return !('getConversationWith' in conversation.conversation);
};
